// https://composition-api.nuxtjs.org/typings/definitionHelpers#definenuxtmiddleware
export default defineNuxtRouteMiddleware((to) => {
  const $pinia = usePinia()
  const authStore = useAuthStore($pinia)

  if (!authStore.isLogin) {
    const urlSearchParams = new URLSearchParams()

    for (const key in to.query) {
      urlSearchParams.set(key, to.query[key] as string)
    }

    urlSearchParams.append('redirect_url', to.fullPath)

    // todo login페이지에서 redirect_url처리 필요
    const url = `${URL_MAP.LOGIN}?${urlSearchParams.toString()}`

    return navigateTo(url, { external: true })
  }
})
